import * as React from 'react'

interface StationItemProps {
  name: string
  distance: number
}

const StationItem: React.SFC<StationItemProps> = ({ name, distance }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        background: 'rgba(255, 255, 255, 0.9)',
        border: '1px solid #BCBCBC',
        boxSizing: 'border-box',
        borderRadius: '5px',
        padding: 10,
        width: '100%',
        marginTop: 20,
      }}
    >
      <div style={{ display: 'flex' }}>
        <div style={{ fontSize: 18, marginRight: '10px' }}> {name}</div>
      </div>
      <div style={{ display: 'flex', marginTop: 10 }}>
        <div style={{ fontWeight: 'bold', fontSize: 14, marginRight: '10px' }}>Distanz:</div>
        <div style={{ fontSize: 14, marginRight: '10px' }}>{distance}m</div>
      </div>
    </div>
  )
}

export default StationItem



// WEBPACK FOOTER //
// ./src/components/station/StationItem.tsx